import React from 'react'
import { Modal, l } from '@manychat/manyui'

export default function WarningModal(props) {
  const { isOpen, onConfirm, onClose, title } = props

  const buttons = [
    {
      label: l.translate('Cancel'),
      onClick: onClose,
      className: 'col-3 m-y-xxs',
    },
    {
      label: l.translate('Confirm'),
      onClick: onConfirm,
      className: 'col-3 m-y-xxs p-x',
      variant: 'primary',
    },
  ]

  return (
    <Modal
      title={title}
      width={440}
      open={isOpen}
      onRequestClose={onClose}
      noContentPadding
      buttons={buttons}
    />
  )
}
